// 窗口内所有浮层的层级；角色划分见 docs/system/ui.md。不依赖 React，启动动画在 App 加载前也能读取。
export const LAYER_Z_INDEX = {
  content: 0,
  sticky: 10,
  localControl: 20,
  localBlocking: 30,
  scopeTakeover: 40,
  scopeTransient: 70,
  scopeTooltip: 80,
  scopeModal: 100,
  globalFeedback: 200,
  globalTransient: 250,
  globalTooltip: 260,
  globalModal: 300,
  blockingModal: 400,
  toast: 500,
  systemGesture: 600,
  startupSplash: 700,
  dialogScrim: 0,
  dialogSurface: 10,
  dialogTransient: 20,
  dialogTooltip: 30
} as const
